// VERSION 2.2 - Bugfix #5 (KO-Phasen-Logik komplett)
// =============================================================================
//  SCREEN: BracketScreen
// =============================================================================
import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import apiClient from '../api';
import { SingleEliminationBracket, Match } from '@g-loot/react-tournament-brackets';
import { toast } from 'react-toastify';
import DuelScoreModal from '../components/DuelScoreModal';

const BracketScreen = () => {
  const { id: tournamentId, gameMode, classification } = useParams();
  
  const [matches, setMatches] = useState([]);
  const [koScores, setKoScores] = useState([]); // Wird weiterhin für das Modal benötigt
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [editingDuel, setEditingDuel] = useState(null);

  const fetchBracketData = async () => {
try {
      setLoading(true);
      // KORRIGIERT: Der API-Pfad wurde an die neue, saubere Route angepasst.
      const { data: formattedMatches } = await apiClient.get(`/api/bracket/${tournamentId}/${gameMode}/${classification}`);
      setMatches(formattedMatches);

      // Wir benötigen die rohen Scores weiterhin, um das Modal zu füllen.
      const { data: rawScores } = await apiClient.get(`/api/tournaments/${tournamentId}/scores`);
      const relevantScores = rawScores.filter(score => 
        score.gameMode === gameMode && 
        score.entry?.classification === classification &&
        score.phase !== 'qualification'
      );
      setKoScores(relevantScores);

    } catch (err) {
      setError("Fehler beim Laden der KO-Phase.");
      toast.error("Fehler beim Laden der KO-Phase.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBracketData();
  }, [tournamentId, gameMode, classification]);

  const handleMatchClick = (match) => {
    const scoreA = koScores.find(s => s._id === match.id);
    if (!scoreA) { toast.error("Fehler: Duell-Daten nicht gefunden."); return; }

    const scoreB = koScores.find(s => s._id === scoreA.opponentScore);
    if (!scoreA.opponentScore || !scoreB) {
      toast.info("Dieses Duell beinhaltet ein Freilos und kann nicht bearbeitet werden.");
      return;
    }
    setEditingDuel({ playerA: scoreA, playerB: scoreB });
  };

  const handleSaveDuel = async (scoreA, scoreB) => {
    try {
        await apiClient.put('/api/duel', { scoreA, scoreB });
        toast.success("Duell-Ergebnis gespeichert.");
        setEditingDuel(null);
        fetchBracketData();
    } catch (err) {
        toast.error(err.response?.data?.message || "Fehler beim Speichern des Duells.");
    }
  };

  if (loading) return <p>Lade KO-Phase...</p>;
  if (error) return <p className="error-message">{error}</p>;

  return (
    <div className="screen-container">
      {editingDuel && (
        <DuelScoreModal
          duel={editingDuel}
          onClose={() => setEditingDuel(null)}
          onSave={handleSaveDuel}
          gameMode={gameMode}
        />
      )}
      <div className="navigation-header">
         <Link to={`/turnier/${tournamentId}/ergebnisse`} className="btn-back">← Zurück zur Ergebnisliste</Link>
      </div>
      <h2>KO-Phase für {gameMode} / {classification}</h2>
      <div style={{ backgroundColor: '#f9f9f9', padding: '1rem', borderRadius: '8px', marginTop: '2rem', minWidth: 'fit-content' }}>
        {matches.length > 0 ? (
          <SingleEliminationBracket
            matches={matches}
            matchComponent={(props) => (
              <Match
                {...props}
                onMatchClick={() => handleMatchClick(props.match)}
                style={{ cursor: 'pointer' }}
              />
            )}
          />
        ) : (
          <p>Für diese Auswahl wurde noch keine KO-Phase generiert oder es gibt noch keine Ergebnisse.</p>
        )}
      </div>
    </div>
  );
};

export default BracketScreen;